import React, { FC, MouseEvent } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ReportIcon from '@mui/icons-material/Report';
import { useTranslation } from 'react-i18next';

type ResolveTransportProblemFlagButtonProps = {
    resolveTransportProblem: () => void;
};
const ResolveTransportProblemFlagButton: FC<ResolveTransportProblemFlagButtonProps> = ({
    resolveTransportProblem,
}: ResolveTransportProblemFlagButtonProps) => {
    const { t: translate } = useTranslation(['transport']);

    const handleClick = (event: MouseEvent) => {
        event.preventDefault();
        event.stopPropagation();
        resolveTransportProblem();
    };
    return (
        <Tooltip title={translate('transport:RESOLVE_TITLE').toString()} placement="right">
            <IconButton size="small" onClick={(event) => handleClick(event)}>
                <ReportIcon color="warning" />
            </IconButton>
        </Tooltip>
    );
};

export default ResolveTransportProblemFlagButton;
